import React, { Component } from "react";
import styles from "./routesListItems.module.scss";
import { withRoutes } from "../../../shared/containers/containerRoutes";
import Icon from "../../../shared/items/static/icon";
import DeleteButton from "../../DeleteButton/DeleteButton";
import ModalConfirmWindow from "../../Contents/ModalComponents/ModalConfirmWindow";
import DeleteConfirm from "../../Contents/ModalComponents/DeleteConfirm";
import { NavLink } from "react-router-dom";

class RoutesListItems extends Component {
  constructor(props) {
    super(props);

    this.state = {
      idForDelete: null,
    };
  }

  onClickHandler(id) {
    const { onSelectRoute } = this.props;
    onSelectRoute(id);

    this.setState({ idForDelete: null });
  }

  onClickUnselectHandler(e) {
    const { onUnselectRoute } = this.props;
    onUnselectRoute();
    this.setState({ idForDelete: null });
  }

  onSetIdForDelete(id) {
    this.setState({ idForDelete: id });
  }

  onDeleteHandler() {
    const { selectedRouteId, onDeleteRoute } = this.props;
    onDeleteRoute({ id: selectedRouteId });
    this.setState({ idForDelete: null });
  }

  render() {
    const { data, selectedRouteId } = this.props;
    const { idForDelete } = this.state;

    return (
      <div className={styles.routeListItemsContainer}>
        {data.map((routeItem) => {
          const directionRoute =
            routeItem.controlPoints.length > 0
              ? `${routeItem.controlPoints[0].title} - ${routeItem.controlPoints[routeItem.controlPoints.length - 1].title}`
              : "";

          return selectedRouteId === routeItem.id ? (
            <div key={routeItem.id} className={styles.routeSelectedItemContainer}>
              <div className={styles.routeTitleContainer}>
                <div>
                  <div>{routeItem.title}</div>
                  <div className={styles.routeControlPointTitle}>{directionRoute}</div>
                </div>
                <div className={styles.routeBntClose} onClick={this.onClickUnselectHandler.bind(this)}>
                  <NavLink
                    to={window.location.pathname.includes("trips") ? "/routes/trips" : "/routes/controlPoints"}
                    className={styles.navigationItem}
                    activeClassName={styles.navigationItem_active}
                  >
                    <Icon name="x" />
                  </NavLink>
                </div>
              </div>
              <div className={styles.routeActionContainer}>
                <DeleteButton
                  text={"Удалить маршрут"}
                  tooltipText={"Удалить маршрут"}
                  handleClick={(e) => {
                    this.onSetIdForDelete(routeItem.id);
                  }}
                  toolTipPosition={"right"}
                />

                {idForDelete ? (
                  <div>
                    {idForDelete ? (
                      <ModalConfirmWindow isOpen={idForDelete}>
                        <DeleteConfirm
                          onConfirmHandle={this.onDeleteHandler.bind(this)}
                          onNotConfirmHandle={(e) => {
                            this.setState({ idForDelete: null });
                          }}
                          text={`Удалить маршрут ${routeItem.title}; ${directionRoute}?`}
                        />
                      </ModalConfirmWindow>
                    ) : null}
                  </div>
                ) : null}
              </div>
            </div>
          ) : (
            <div key={routeItem.id} className={styles.routeItemContainer} onClick={this.onClickHandler.bind(this, routeItem.id)}>
              <NavLink
                to={window.location.pathname.includes("trips") ? `/routes/${routeItem.id}/trips` : `/routes/${routeItem.id}/controlPoints`}
                className={styles.navigationItem}
                activeClassName={styles.navigationItem_active}
              >
                <div>{routeItem.title}</div>
                <div className={styles.routeControlPointTitle}>
                  {routeItem.controlPoints.length > 0
                    ? `${routeItem.controlPoints[0].title} - ${routeItem.controlPoints[routeItem.controlPoints.length - 1].title}`
                    : null}
                </div>
              </NavLink>
            </div>
          );
        })}
      </div>
    );
  }
}

export default withRoutes(RoutesListItems);
